import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { logger } from '../services/logger';
import AppLayout from '../components/layout/AppLayout';

// Import page components
import HomePage from '../pages/HomePage';
import AnalysisPage from '../pages/AnalysisPage';
import WindowsPage from '../pages/WindowsPage';
import StepsPage from '../pages/StepsPage';
import TestPage from '../pages/TestPage';

/**
 * Router component that sets up application routes using hash routing
 * Hash routing is used to ensure compatibility with static hosting providers
 */
const AppRouter: React.FC = () => {
  logger.debug('Router initialized with hash routing');
  
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route index element={<HomePage />} />
          <Route path="analysis" element={<AnalysisPage />} />
          <Route path="windows" element={<WindowsPage />} />
          <Route path="steps" element={<StepsPage />} />
          <Route path="test" element={<TestPage />} />
          {/* Redirect any unknown routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </HashRouter>
  );
};

export default AppRouter; 